"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("./constants");
/**
 * @param offerId - The offerId to use for the request
 * @param isWithinRenewalGracePeriod - Whether the customer is within the renewal grace period (available from svc-membership)
 * @returns magic offerId used for the LuxPlus+ renewal bonus request if the customer is within the renewal grace period
 */
function getLuxPlusBonusRequestOfferId(offerId, isWithinRenewalGracePeriod) {
    if (!isWithinRenewalGracePeriod)
        return offerId;
    return `${offerId};${constants_1.LUX_LOYALTY_LUX_PLUS_ELIGIBLE_RENEWAL_BONUS_ID}`;
}
exports.default = getLuxPlusBonusRequestOfferId;
